/**
 * Match-request claim client (unauthenticated). Talks to the recruiter-api
 * public routes via the gateway: /api/v1/public/match-requests/{token}.
 */

import { api } from './api';

export interface PublicMatchView {
  can_show_interest: boolean;
  state: string;
  job_title: string;
  location?: string | null;
  remote_allowed: boolean;
  employment_type: string;
  salary_min?: number | null;
  salary_max?: number | null;
  salary_currency: string;
  industry?: string | null;
  department?: string | null;
}

export function getMatchClaim(token: string): Promise<PublicMatchView> {
  return api.get<PublicMatchView>(`/public/match-requests/${encodeURIComponent(token)}`);
}

export function expressInterest(token: string): Promise<{ state: string }> {
  return api.post<{ state: string }>(
    `/public/match-requests/${encodeURIComponent(token)}/interest`,
  );
}

export function declineMatch(token: string, reason?: string): Promise<{ state: string }> {
  return api.post<{ state: string }>(
    `/public/match-requests/${encodeURIComponent(token)}/decline`,
    reason ? { reason } : {},
  );
}
